import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-slideshow-line"></i>
            编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队为你精选的观影专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="aspect-[16/10] relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-background-100/80 text-foreground-600 text-[10px] font-medium backdrop-blur-sm">{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}